import { DEFAULT_PROMO_DRAWER } from '../elements/feeStructureForm/elements/freeAdvances/freeAdvances.constants';

/**
 * Setters for the member-promo Groups section's local UI state
 * (state.tabs.memberPromos). Mirrors dashboard.delegate.js's drawer pattern:
 * open/close reset the whole `drawer` slice to a default shape, field
 * setters shallow-merge into it.
 */
class MemberPromosDelegate {
    setLoadingGroups(loadingGroups) {
        this.setState({ loadingGroups });
    }

    removeGroup(promoId) {
        this.setState((prev) => ({ groups: prev.groups.filter((g) => g.id !== promoId) }));
    }

    replaceDrawer(nextDrawer) {
        this.setState({ drawer: nextDrawer });
    }

    patchDrawer(partial) {
        this.setState((prev) => ({ drawer: { ...prev.drawer, ...partial } }));
    }

    resetDrawer() {
        this.setState({ drawer: { ...DEFAULT_PROMO_DRAWER } });
    }
}

export default MemberPromosDelegate;
